<template>
  <div class="EMPreview">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        title="历史工单"
        class="customer-edit"
        :close-on-click-modal="false"
        width="1000px"
        top="10vh">
      <el-table
          :data="emRepairOrder"
          style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
                :data="props.row.emRepairOrderDetailVOS"
                style="width: 100%">
              <el-table-column label="处理方法" align="center" prop="repairMethod">
                <template slot-scope="scope">
                  <span>{{constant.dealMethod[scope.row.repairMethod]}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="beginTime" align="center" label="开始时间"/>
              <el-table-column prop="endTime" align="center" label="结束时间"/>
              <el-table-column prop="estimatedCost" align="center" label="预估费用"/>
              <el-table-column prop="repairMan" align="center" label="维修人员"/>
              <el-table-column prop="repairContent" align="center" label="维修内容"/>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column align="center" label="故障描述" prop="faultDesc"/>
        <el-table-column align="center" width="150px" label="故障时间" prop="faultTime"/>
        <el-table-column align="center" label="报修人" prop="creatorName"/>
        <el-table-column align="center" width="150px" label="报修时间" prop="createTime"/>
        <el-table-column align="center" label="维修负责人" prop="mainRepairMan"/>
        <el-table-column align="center" label="确认人" prop="confirmName"/>
        <el-table-column align="center" width="150px" label="确认时间" prop="confirmTime"/>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    name:"EquipmentHistoryOrder",
    components: {},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        emRepairOrder: [],
        activeName: "first",
        value: "",
        ruleValidate: {
          postName: {required: true, message: "不能为空",trigger: "blur"},
          parentName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.emRepairOrder.pkid = id;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", `repairOrders/equipmentId/${this.emRepairOrder.pkid}`)
          .then(resp => {
            console.log(resp);
            this.emRepairOrder = resp;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .EMPreview{
    .el-form-item__content{
      margin-left: 2%!important;
    }
    .table{
      width: 100%;
      border: 1px solid #cccccc;
      margin-bottom: 3%;
      tr{
        display: flex;
        flex-direction: row;
        td{
          width: 50%;
          height: 40px;
          line-height: 40px;
          border-bottom: 1px solid #cccccc;
          display: flex;
          flex-direction: row;
          padding: 0;
          span{
            display: block;
            padding-right: 2%;
            margin-right: 2%;
            width: 28%;
            height: 40px;
            line-height: 40px;
            background: #f5f5f5;
            border-right: 1px solid #cccccc;
            text-align: right;
          }
          .el-radio {
            line-height: 40px;
            margin-right: 10px;
            .el-radio__label{
              padding-left: 2px!important;
            }
          }
        }
        td:nth-child(1){
          border-right: 1px solid #cccccc;
        }
      }
    }
  }
</style>
